import { render } from "./product-create-import.vue?vue&type=template&id=472d733e"
import script from "./product-create-import.vue?vue&type=script&lang=js"
export * from "./product-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__